import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { isAuthLoggedIn } from 'modules/auth/selectors';

const { REACT_APP_CHAT_WITH_URL } = process.env;

const ChatWithScript = () => {
  const isLoggedIn = useSelector(isAuthLoggedIn);
  const scriptRef = useRef(null);

  // Function to clean up the ChatWith widget elements
  const cleanupChatWithElements = () => {
    const elements = document.querySelectorAll('[id^="chatwith-"]');
    elements.forEach((element) => {
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    });
  };

  useEffect(() => {
    if (isLoggedIn && !scriptRef.current) {
      const script = document.createElement('script');
      script.src = REACT_APP_CHAT_WITH_URL;
      script.async = true;

      document.head.appendChild(script);
      scriptRef.current = script;
    }

    if (!isLoggedIn) {
      if (scriptRef.current) {
        document.head.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
      cleanupChatWithElements();
    }
  }, [isLoggedIn]);

  return null;
};

export default ChatWithScript;
